import { translationData } from './data';

export function getTranslation(state: any, id: number): string {
    let translate = state.initReducer.translations[id];
    if (translate) {
        return translate;
    }

    translate = translationData[id];
    return translate ? translate : `can't find translation for id:[${id}]`;
};